import { UserInfoV2 } from "../ducks/ManageUsers.model";
import { Permission } from '@shared/models/user.models';
import { Pill } from '@shared/ui/atoms/Pill';
import Colours from '@shared/ui/atoms/Colours';
import { BodySmall, BodyVerySmall } from '@shared/ui/atoms/fonts/Body';
import React from "react";

export function UserRolePill(props: Props) {
  const {user, role} = props
  const userRole = user?.role ?? role ?? Permission.Basic;
  if (userRole === Permission.CompanyAdmin) {
    return (<Pill style={{width: 150, borderColor: Colours.plannerGreen}} colour={Colours.black} backgroundColour={Colours.plannerGreen}>
      <BodySmall weight={400}>Company admin</BodySmall>
    </Pill>)
  } else if (userRole === Permission.TeamAdmin) {
    return (<Pill style={{width: 140, borderColor: Colours.plannerGreen}} colour={Colours.black} backgroundColour={Colours.plannerGreen}>
      <BodySmall weight={400}>Team Admin</BodySmall>
    </Pill>)
  } else if (userRole === Permission.OfficeAdmin) {
    return (<Pill style={{width: 150, borderColor: Colours.plannerGreen}} colour={Colours.black} backgroundColour={Colours.plannerGreen}>
      <BodySmall weight={400}>Office Admin</BodySmall>
    </Pill>)
  } else if (userRole === Permission.DepartmentAdmin) {
    return (<Pill style={{width: 150, borderColor: Colours.plannerGreen}} colour={Colours.black} backgroundColour={Colours.plannerGreen}>
      <BodyVerySmall weight={400}>Department Admin</BodyVerySmall>
    </Pill>)
  }
  return null;
}

interface Props {
  user?: UserInfoV2;
  role?: Permission
}
